import { render } from "./DrinkThree.vue?vue&type=template&id=e81ab146"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/DrinkThree.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e81ab146"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e81ab146', __exports__)) {
    api.reload('e81ab146', __exports__)
  }
  
  module.hot.accept("./DrinkThree.vue?vue&type=template&id=e81ab146", () => {
    api.rerender('e81ab146', render)
  })

}


export default __exports__